import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { feedConfig } from '../config/navConfig';
import { emailFormKeys } from '../config/commonConfig';

import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from './Tooltip';

const Contact = ({ darkTheme, lang }) => {
  const form = useRef();
  const [sendingMail, setSendingMail] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setSendingMail(true);
    emailjs
      .sendForm(
        'service_i86k3ms',
        'template_si6cin9',
        form.current,
        'c9HsDgGF0tvWyVnAL'
      )
      .then(
        (result) => {
          document.getElementById('contact-form').reset();
          toast.success('Message sent successfully!', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: darkTheme ? 'dark' : 'light',
          });
          console.log(result.text);
          setSendingMail(false);
        },
        (error) => {
          toast.error('Something went wrong!', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: darkTheme ? 'dark' : 'light',
          });
          console.log(error.text);
          setSendingMail(false);
        }
      );
  };

  return (
    <section id="contact" className="section main-padding">
      <div className={''}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <p className={'text-9 text-dark fw-600 w-100 text-start text-white '}>
            <FormattedMessage id="contact-us" defaultMessage="Get in touch!" />
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5 mb-5">
          {/* contact details */}
          <div className="col-md-4 col-xl-4 order-1 order-md-0 text-center text-md-start">
            <h2
              className={
                'mb-3 text-5 text-uppercase ' + (darkTheme ? 'text-white' : '')
              }>
              <FormattedMessage id="contact-address" defaultMessage="Address" />
            </h2>
            <p className={'text-3 mb-4 ' + (darkTheme ? 'text-light' : '')}>
              Secteur KH, Lot 31, Parcelle 15
              <br />
              Ouagadougou, Burkina Faso
              <br />
              S/C 12 BP 154 , Ouagadougou 12
            </p>
            <p className={'text-3 mb-4 ' + (darkTheme ? 'text-light' : '')}>
              381 Rue Mozart
              <br />
              Saint-Jean-Sur-Richelieu
              <br />
              J3B 8T6 QC , CA
            </p>
            <p className={'text-3 mb-1 ' + (darkTheme ? 'text-light' : '')}>
              <span className="text-primary text-4 me-2">
                <i className="fas fa-phone" />
              </span>
              (+226) 76 34 63 76
            </p>
            <p className={'text-3 mb-1 ' + (darkTheme ? 'text-light' : '')}>
              <span className="text-primary text-4 me-2">
                <i className="fas fa-phone" />
              </span>
              (+1) 514 562-3391
            </p>
            <p className={'text-3 mb-1 ' + (darkTheme ? 'text-light' : '')}>
              <span className="text-primary text-4 me-2">
                <i className="fas fa-phone" />
              </span>
              (+1) 514 516 6173
            </p>
            {/* <p className={'text-3 mb-1 ' + (darkTheme ? 'text-light' : '')}>
              <span className="text-primary text-4 me-2">
                <i className="fas fa-fax" />
              </span>
              (+1) 514 516 6173
            </p> */}
            <p className={'text-3 mb-4 ' + (darkTheme ? 'text-light' : '')}>
              <span className="text-primary text-4 me-2">
                <i className="fas fa-envelope" />
              </span>
              chat@gonumerik.com
            </p>
            <ul
              className={
                'social-icons justify-content-center justify-content-md-start ' +
                (darkTheme ? 'social-icons-muted' : '')
              }>
              {feedConfig.map((config) => (
                <li key={config.href} className="social-icons-facebook">
                  <Tooltip text={config.text} placement="top">
                    <a
                      href={config.href}
                      target="_blank"
                      rel="noopener noreferrer">
                      <i className={config.className} />
                    </a>
                  </Tooltip>
                </li>
              ))}
            </ul>
          </div>
          {/* contact form */}
          <div className="col-md-8 col-xl-8 order-0 order-md-1">
            <h2
              className={
                'mb-3 text-5 text-uppercase text-center text-md-start ' +
                (darkTheme ? 'text-white' : '')
              }>
              <FormattedMessage
                id="contact-send"
                defaultMessage="Send us note"
              />
            </h2>
            <form
              className={darkTheme ? 'form-dark' : ''}
              id="contact-form"
              action="php/mail.php"
              method="post"
              ref={form}
              onSubmit={sendEmail}>
              <div className="row g-4">
                <div className="col-xl-6">
                  <input
                    name="user_name"
                    type="text"
                    className="form-control"
                    required
                    placeholder={emailFormKeys[lang].sender}
                  />
                </div>
                <div className="col-xl-6">
                  <input
                    name="user_email"
                    type="email"
                    className="form-control"
                    required
                    placeholder={emailFormKeys[lang].email}
                  />
                </div>
                <div className="col">
                  <textarea
                    name="message"
                    className="form-control"
                    rows={5}
                    required
                    placeholder={emailFormKeys[lang].note}
                    defaultValue={''}
                  />
                </div>
              </div>
              <p className="text-center mt-4 mb-0">
                <button
                  id="submit-btn"
                  className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                  type="submit">
                  {sendingMail ? (
                    <>
                      <span
                        role="status"
                        aria-hidden="true"
                        className="spinner-border spinner-border-sm align-self-center me-2"></span>
                      <FormattedMessage
                        id="contact-sending"
                        defaultMessage="Sending..."
                      />
                    </>
                  ) : (
                    <FormattedMessage
                      id="contact-send-now"
                      defaultMessage="Send Message"
                    />
                  )}
                </button>
              </p>
              <ToastContainer />
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
